var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefault({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "180px",
    height: "180px",
    viewBox: "0 0 180 180",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180,90 C180,139.707692 139.707692,180 90,180 C40.2923077,180 0,139.707692 0,90 C0,40.2923077 40.2923077,0 90,0 C139.707692,0 180,40.2923077 180,90 Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.4,52.9333332 C147.299378,56.8375672 147.299378,63.1624326 143.4,67.0666666 L83.4,127.066667 C79.495766,130.966045 73.1709006,130.966045 69.2666666,127.066667 L35.9333332,93.7333332 C32.2618822,89.7932031 32.3702156,83.6532039 36.1783764,79.845043 C39.9865373,76.0368822 46.1265365,75.9285489 50.0666666,79.6 L76.3333332,105.853333 L129.266667,52.92 C133.170901,49.0206216 139.495766,49.0206216 143.4,52.92 L143.4,52.9333332 Z",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.6347c8b090f53d84e7565e25de88e89a.svg";
export { ForwardRef as ReactComponent };